"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTitleCase = toTitleCase;
exports.truncate = truncate;
exports.round = round;
const constants_1 = require("../constants");
const web3_1 = require("./web3");
function toTitleCase(str) {
    var _a;
    if (!str)
        return;
    const words = (_a = str.split(' ')) === null || _a === void 0 ? void 0 : _a.map((w) => w.toLowerCase());
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words.join(' ');
}
function truncate(s, amount) {
    if (!s)
        return s;
    if (s === 'N/A')
        return s;
    return `${s.slice(0, amount ? amount : 4)}...${s.slice(amount ? amount * -1 : -4)}`;
}
function round(value, options) {
    var _a;
    let _value;
    if (typeof value === 'bigint') {
        _value = (0, web3_1.toNormalizedBn)(value, (_a = options.decimals) !== null && _a !== void 0 ? _a : constants_1.FALLBACK_DECIMALS).normalized;
    }
    else {
        _value = String(value);
        if (_value.includes(' '))
            _value = _value.split(' ')[0];
    }
    if (options === null || options === void 0 ? void 0 : options.usd) {
        const usdFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        const valueNumber = Number(_value);
        return usdFormatter.format(valueNumber);
    }
    if (_value === '0' || _value === '0.0')
        return '0.000';
    if ((options === null || options === void 0 ? void 0 : options.showing) === 'all') {
        return _value;
    }
    else {
        const _showing = () => {
            if ((options === null || options === void 0 ? void 0 : options.showing) && typeof options.showing === 'number')
                return options === null || options === void 0 ? void 0 : options.showing;
            if (options === null || options === void 0 ? void 0 : options.usd)
                return 2;
            if ((_value === null || _value === void 0 ? void 0 : _value.length) && (_value === null || _value === void 0 ? void 0 : _value.length) > 6)
                return 6;
            return 4;
        };
        const numberFormatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: _showing(),
            maximumFractionDigits: _showing(),
        });
        return numberFormatter.format(Number(_value));
    }
}
//# sourceMappingURL=formatters.js.map